<div class="grid-loading-overlay">
  <div class="loading-content">
    <app-shared-loading-g
      [animation]="animation">
    </app-shared-loading-g>
  </div>
</div>

